import {
    IPropertyPaneButtonProps
} from '@microsoft/sp-webpart-base';

export class ICustomButtonPaneProps implements IPropertyPaneButtonProps {
    public text: string;
    public type: any;
    public onClick: (value: any) => any;
}